<template>
  <div class="mb-4">
    <div class="text-subtitle-2 mb-2">{{ $t('routes.webhookIntegrations.eventSubscriptions') }} *</div>

    <v-expansion-panels variant="accordion" multiple>
      <v-expansion-panel v-for="group in eventGroups" :key="group.key">
        <v-expansion-panel-title>
          {{ $t(`routes.webhookIntegrations.eventGroups.${group.key}`) }}
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-checkbox
            :model-value="isGroupSelected(group)"
            :label="$t('routes.webhookIntegrations.selectAll')"
            density="compact"
            hide-details
            @update:model-value="toggleGroup(group, $event)"
          />
          <v-checkbox
            v-for="eventType in group.events"
            :key="eventType"
            :model-value="selectedEvents.includes(eventType)"
            :label="$t(`routes.webhookIntegrations.events.${getEventTranslationKey(eventType)}`)"
            density="compact"
            hide-details
            @update:model-value="toggleEvent(eventType, $event)"
          />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <div v-if="showError" class="text-error text-caption mt-2">
      {{ $t('routes.webhookIntegrations.eventSubscriptionsRequired') }}
    </div>
  </div>
</template>

<script>
import { EVENT_GROUPS, getEventTranslationKey } from '../WebhookConstants.js';

export default {
  name: 'WebhookEventSubscriptionsInput',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    showError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    eventGroups() {
      return EVENT_GROUPS;
    },
    selectedEvents() {
      return this.modelValue.filter((eventType) => eventType !== 'webhook.test');
    },
  },
  methods: {
    getEventTranslationKey,
    isGroupSelected(group) {
      return group.events.every((eventType) => this.selectedEvents.includes(eventType));
    },
    toggleGroup(group, selected) {
      const withoutGroup = this.selectedEvents.filter((eventType) => !group.events.includes(eventType));
      this.$emit('update:modelValue', selected ? [...withoutGroup, ...group.events] : withoutGroup);
    },
    toggleEvent(eventType, selected) {
      const events = selected
        ? [...this.selectedEvents, eventType]
        : this.selectedEvents.filter((selectedEvent) => selectedEvent !== eventType);

      this.$emit('update:modelValue', [...new Set(events)]);
    },
  },
}
</script>
